import { createReduxAsyncThunk } from 'shared/utils';

import { stationsAPI } from 'entities/stations';

import { STATIONS_STATE } from '../../constants';

import { AxiosResponse } from 'axios';

export const createStationsPriceReport = createReduxAsyncThunk<
  AxiosResponse<any, any>
>(
  `${STATIONS_STATE}/createStationsPriceReport`,
  async () => {
    return await stationsAPI.createStationsPriceReport();
  }
);
